<template>
	<div>
		<div class="orders">
			<div class="nope" v-if="!orders.length && ended">
				Заказов нет
			</div>

			<div class="order" v-for="order in orders" :key="order.id">
				<div class="title">
					#{{ order.oid }}
					<span>{{ order.status }} &nbsp; {{ order.statusIcon }} </span>
				</div>
				<div class="info">{{ format(order.createdAt) }}</div>
				<div class="info">{{ order.address.address }}</div>

				<div class="devider" />

				<div class="dish" v-for="dish in order.dishes" :key="dish._id">
					{{ dish.dish.name }}
					<span>x{{ dish.count }}</span>
				</div>
				<div class="dish">
					Приборы
					<span>x{{ order.cutlery }}</span>
				</div>

				<div class="devider" />

				<div class="info">Сумма: {{ order.fullPrice }} ₽</div>
				<div class="info">Бонусы: {{ order.bonusesPrice || 0 }}</div>
				<div class="info" v-if="order.paymentMethod">
					Оплата: {{ order.paymentMethod.number }}
				</div>
				<div class="info" v-if="order.completed">
					Доставлен {{ format(order.completedAt) }}
				</div>
			</div>
		</div>

		<uiButton @click="load" :loading="loading" color="grey" v-if="!ended">
			Загрузить
		</uiButton>
	</div>
</template>

<script>
import { API } from '@/config'
import { format } from 'date-fns'

export default {
	name: 'UserBonuses',
	props: {
		user: String,
	},
	data() {
		return {
			loading: false,
			ended: false,
			orders: [],
		}
	},
	computed: {
		bonuses() {
			return parseInt(this.rawBonuses) || 0
		},
		valid() {
			return this.bonuses && this.reason.length > 3
		},
	},
	watch: {
		user() {
			this.orders = []
			this.ended = false
		},
	},
	methods: {
		async load() {
			if (this.loading) return
			this.loading = true

			let payload = {
				user: this.user,
				limit: this.orders.length,
			}
			let { data } = await this.$http.post(API.USERS.orders, payload)
			if (!data || data.err) {
				this.$notify(data.err)
				return (this.loading = false)
			}

			console.log(data)

			if (data && data.length < 30) this.ended = true

			this.orders = this.orders.concat(data)
			this.loading = false
		},
		format(date) {
			return format(new Date(date), 'dd.MM.yyyy HH:mm')
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.order {
	width: calc(100% - 20px);
	height: fit-content;
	background: @grey;
	border-radius: 10px;
	margin-bottom: 10px;
	padding: 10px;
	font-size: 14px;
}

.devider {
	width: 100%;
	height: 1px;
	background: rgba(0, 0, 0, 0.1);
	margin: 10px 0;
}

.dish {
	margin-bottom: 5px;

	span {
		opacity: 0.7;
	}
}

.title {
	font-weight: bold;
}

.info {
	flex: 1;
}

.nope {
	text-align: center;
	padding: 10px 0;
	padding-bottom: 20px;
	opacity: 0.5;
}
</style>
